import React, {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import UseTexFile from "./Customhook/UseTexFile";
import { setupF3Search, cleanupF3Search } from "./Functionalities/F3Search"
import ace from "ace-builds/src-noconflict/ace";
import "ace-builds/src-noconflict/theme-dracula";
import "ace-builds/src-noconflict/theme-terminal";
import "ace-builds/src-noconflict/theme-monokai";
import "ace-builds/src-noconflict/mode-javascript";
import AceEditor from "react-ace";
import "ace-builds/src-noconflict/mode-latex";
// import "ace-builds/src-noconflict/mode-text";
import "ace-builds/src-noconflict/theme-xcode";
import "ace-builds/src-noconflict/ext-language_tools";
import "ace-builds/src-noconflict/ext-searchbox";
import "ace-builds/src-noconflict/ext-spellcheck";
import { enableSpellCheck } from "./SpellCheck";
import styles from "./Ace.module.css";
import { latexParser } from "latex-utensils";
import { FileParser } from "./FileParser";
import { HStack, IconButton, ButtonGroup, Tooltip, Modal, ModalBody, useDisclosure, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, Box, Button, Spinner, FormControl, FormLabel, Switch, Text, position, Stack, Flex, ModalFooter } from "@chakra-ui/react";
import PopOver from "./Popover";
import { JumpFunctionality } from "./JumpFunctionality"
import {
  getAllBibitems,
  getAllEquations,
  getAllTables,
  showDeletedOnHover,
  querySelector,
  processSelection
} from "../Utils/utils";
import { getCitationMarkers, getInlineEqnMarkers, getEqnMarkers } from "../Utils/getMarkers";
import CitationPopup from "./CitationPopup";
import MathPopup from "./MathPopup";
// import { saveTexApi, downloadTexApi } from "../api";
import ImagePopup from "./ImagePopup";
import CommentPopup from "./CommentPopup";
import { InsertMath } from "./InsertMath";
import { diff_match_patch } from "diff-match-patch";
import { TiTick } from "react-icons/ti";
import { setupLatexAutocomplete } from "./setupLatexAutocomplete";
import { VscFileCode, VscClose } from "react-icons/vsc";
import {
  SaveIcon, SearchIcon, Undo, RefreshIcon, ReplaceIcon, BoldIcon, ItalicIcon, Auto, Resize1, Resize2, MenuBar, MenuClose, HideChange,
  ShowChange,
  Redo,
  Langchange
} from "./icons";
import { connect } from "react-redux";
import { epl } from "../clientstyles/epl"
import { edp } from "../clientstyles/edp"
import { useNavigate, useParams } from "react-router-dom";
import Loading from "./Loading";

import { textToBold, textToItalics } from "../Utils/shortcutBindings"

import { get_all_project_file_Api, update_project_file_Api } from "../dashboardapi";
import { aceShortcuts } from "./AceShortcuts";
import aces from "ace-builds";
import ReusableModal from "./EditTools/Modal";
import { useTheme } from "../Themes/ThemeContext";
import { insertUnusedReferenceQueries } from "./insertUnusedReferenceQueries";
import UseSetAllFiles from "./Customhook/UseSetAllFiles";
import { AutoSuggestion, clearAutoSuggestions, acceptItem, rejectItem } from "./AutoSuggestion";
import { eplStyles } from "../clientstyles/commonstyles";
import FileViewer from "./FileViewer";
import { useCollaborativeEditing } from "./useCollaborativeEditing";
import { IoClose } from "react-icons/io5";

import {
  Drawer, DrawerBody, DrawerHeader, DrawerOverlay,
  DrawerContent, DrawerCloseButton
} from "@chakra-ui/react";
import WildcardSearch from "./Wildcardsearch";
import { SpellingSidebar } from "./SpellingSidebar";
// import { debounce } from "lodash";
// import Tablepopup from "./Tablepopup";
// import { useAceFontObserver } from "./useAceFontObserver";
ace.config.set("basePath", "/ace");

const AceFunctional = forwardRef((props, ref) => {
  const {
    isOpen: alertOpen,
    onToggle: onalertToogle,
    onClose: onalertClose,
  } = useDisclosure();

  const { theme: customtheme } = useTheme()
  const toast = props.toast;
  const aceRef = useRef(null);

  const editorRef = useRef(null);
  window.editor = aceRef;
  const [texFile, setTexFile] = useState("");
  const { isOpen: suggestOpen, onOpen: suggestToggle, onClose: suggestClose } = useDisclosure();


  // Disclosure for Drawer
  const { isOpen, onOpen, onClose } = useDisclosure();



  // Spelling Stats State
  const [stats, setStats] = useState({});
  const [currentKey, setCurrentKey] = useState(null);

  const US_TO_UK = {
    color: "colour", colors: "colours", center: "centre", centers: "centres",
    analyze: "analyse", analyzes: "analyses", organize: "organise",
    organizes: "organises", recognize: "recognise", recognizes: "recognises",
    behavior: "behaviour", behaviors: "behaviours", favor: "favour",
    favors: "favours", honor: "honour", honors: "honours", labor: "labour",
    labors: "labours", meter: "metre", meters: "metres", fiber: "fibre",
    fibers: "fibres", defense: "defence", offense: "offence",
    license: "licence", catalog: "catalogue", dialog: "dialogue",
    gray: "grey", aluminum: "aluminium", fulfill: "fulfil",
    enrollment: "enrolment", program: "programme",
  };

  const UK_TO_US = Object.fromEntries(Object.entries(US_TO_UK).map(([k, v]) => [v, k]));
  // const ALL_US = new Set(Object.keys(US_TO_UK));
  // const ALL_UK = new Set(Object.keys(UK_TO_US));
  const ALL_US = new Set(Object.keys(US_TO_UK));
  const ALL_UK = new Set(Object.keys(Object.fromEntries(Object.entries(US_TO_UK).map(([k, v]) => [v, k]))));


  const updateSpellingStats = useCallback(() => {
    const editor = aceRef.current?.editor;
    if (!editor) return;

    const text = editor.getValue();

    const words = (text.toLowerCase().match(/\b[a-z]+\b/g) || []);
    const newStats = {};

    words.forEach((w) => {

      const isUS = ALL_US.has(w);
      const isUK = ALL_UK.has(w);

      if (isUS || isUK) {
        // 2. Identify the pair (US/UK)
        const us = isUS ? w : UK_TO_US[w];
        const uk = isUS ? US_TO_UK[w] : w;
        const key = `${us}/${uk}`;

        // 3. Initialize entry if new
        if (!newStats[key]) {
          newStats[key] = { us, uk, usCount: 0, ukCount: 0 };
        }

        // 4. Increment dynamically
        if (isUS) newStats[key].usCount++;
        else newStats[key].ukCount++;
      }
    });

    console.log("Dynamic Stats Found:", newStats);
    setStats(newStats);


    if (Object.keys(newStats).length > 0 && !currentKey) {
      setCurrentKey(Object.keys(newStats)[0]);
    }
  }, [currentKey]);



  useEffect(() => {

    if (isOpen) {
      updateSpellingStats();
    }
  }, [isOpen, updateSpellingStats]);


  // Total calculation
  const allKeys = Object.keys(stats);
  const totalUS = allKeys.reduce((acc, k) => acc + stats[k].usCount, 0);
  const totalUK = allKeys.reduce((acc, k) => acc + stats[k].ukCount, 0);
  const cur = currentKey ? stats[currentKey] : null;

  function analyzeText(text) {

    const words = (text.toLowerCase().match(/\b[a-z]+\b/g) || []);
    const stats = {};

    words.forEach((w) => {

      if (ALL_US.has(w)) {
        const uk = US_TO_UK[w];
        const key = `${w}/${uk}`; // e.g., "color/colour"
        if (!stats[key]) stats[key] = { us: w, uk, usCount: 0, ukCount: 0 };
        stats[key].usCount++;
      }
      // If it's a UK word, find the US equivalent
      else if (ALL_UK.has(w)) {
        const us = UK_TO_US[w];
        const key = `${us}/${w}`;
        if (!stats[key]) stats[key] = { us, uk: w, usCount: 0, ukCount: 0 };
        stats[key].ukCount++;
      }
    });
    return stats;
  }

  function replaceWords(text, from, to) {
    // \b -> word boundary, 'gi' -> global and case insensitive
    const re = new RegExp(`\\b${from}\\b`, "gi");

    return text.replace(re, (match) => {
      // Check if the original word was capitalized (e.g., 'Color' -> 'Colour')
      if (match[0] === match[0].toUpperCase()) {
        return to.charAt(0).toUpperCase() + to.slice(1);
      }
      return to;
    });
  }

  // Conversion function
  // 1. Convert Function Fix
  const handleConvert = (dir, wordKey) => {

    const item = stats[wordKey];
    if (!item || !aceRef.current?.editor) return;

    const { us, uk } = item;
    const from = dir === "US" ? uk : us;
    const to = dir === "US" ? us : uk;

    const editor = aceRef.current.editor;
    const currentText = editor.getValue();

    // Replace logic
    const re = new RegExp(`\\b${from}\\b`, "gi");
    const next = currentText.replace(re, (match) => {
      return (match[0] === match[0].toUpperCase()) ? (to.charAt(0).toUpperCase() + to.slice(1)) : to;
    });

    editor.setValue(next, 1);
    updateSpellingStats(); // UI-ai update panna
  };

  const handleMajor = (key) => {
    const item = stats[key];
    if (!item) return;
    // Logic: if US count is greater or equal, keep US (convert UK to US)
    const direction = item.usCount >= item.ukCount ? "US" : "UK";
    handleConvert(direction, key);
  };




  let stylesavailable = false;
  const [wildcardOpen, setWildcardOpen] = useState(false);
  const [notInitialRender, setNotInitialRender] = useState(false)
  const [filename, setFilename] = useState("");
  const [markers, setMarkers] = useState([]);
  const [bibitems, setBibitems] = useState({});
  const [equations, setEquations] = useState({});
  const [tables, setTables] = useState({});
  const [actualValue, setActualValue] = useState("");
  const [toolActualValue, setToolActualValue] = useState("");
  const [lastSearch, setLastSearch] = useState("");
  const [check, setCheck] = useState(false);
  const [toggleChange, setToggleChange] = useState(true);
  const [changes, setChanges] = useState([]);
  const [fileId, setFileID] = useState("");
  const navigate = useNavigate();
  const { projectid, file } = useParams();
  const [isDirty, setIsDirty] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  // const [Allfiles, setAllFiles] = useState({});
  const { Allfiles, setAllFiles } = UseSetAllFiles();
  const suggestionGenRef = useRef(0);
  const changeTimeoutRef = useRef(null);
  useEffect(() => {
    setWildcardOpen(false);
  }, [file]);
  // const handleConvert = (type) => {
  //   console.log("Converting to:", type);
  //   // Unge logic inga varanum
  // };

  // const handleMajorOccurrence = () => {
  //   console.log("Converting to major occurrence");
  //   // Unge logic inga varanum
  // };

  useEffect(() => {
    if (ace?.current) {
      clearAutoSuggestions(ace);
    }
    return () => {
      if (changeTimeoutRef.current) {
        clearTimeout(changeTimeoutRef.current);
      }
    };
  }, [props.clearAllTrigger]);

  // WebSocket State
  const [useWebSocket, setUseWebSocket] = useState(true);
  const [showMockSync, setShowMockSync] = useState(false); // Change to true to show mock cursors
  const [mockConfig] = useState({
    jane: { name: "Jane Author", row: 3, col: 15, color: "#E91E63", bgColor: "rgba(233, 30, 99, 0.3)" },
    // john: { name: "John (Editor)", row: 8, col: 45, color: "#2196F3", bgColor: "rgba(33, 150, 243, 0.3)" }
  });


  useEffect(() => {
    const editor = aceRef.current?.editor;
    const session = editor?.session;


    const styleId = "mock-cursor-styles";
    let style = document.getElementById(styleId);
    if (!style) {
      style = document.createElement("style");
      style.id = styleId;
      document.head.appendChild(style);
    }


    style.innerHTML = Object.entries(mockConfig).map(([key, config]) => `
          .mock-cursor-${key} {
              position: absolute;
              border-bottom: 2px solid ${config.color || '#E91E63'};
              background-color: ${config.bgColor || 'rgba(233, 30, 99, 0.3)'};
              z-index: 1000;
          }
          .mock-cursor-${key}::after {
              content: "${config.name}";
              position: absolute;
              top: -18px;
              left: -2px;
              font-size: 10px;
              color: #fff;
              background: ${config.color || '#E91E63'};
              padding: 2px 6px;
              border-radius: 4px;
              white-space: nowrap;
              font-weight: 600;
              pointer-events: none;
              box-shadow: 0 2px 4px rgba(0,0,0,0.2);
          }
      `).join('');

    if (showMockSync && editor && session) {
      const Range = window.ace.require("ace/range").Range;


      Object.entries(mockConfig).forEach(([key, config]) => {
        session.addMarker(
          new Range(config.row, config.col, config.row, config.col + 2),
          `mock-cursor-${key}`,
          "text",
          true
        );
      });

    } else {
      // Cleanup all markers if mock sync is off
      if (editor && session) {
        const markers = session.getMarkers(true);
        for (let id in markers) {
          if (markers[id].clazz && markers[id].clazz.includes("mock-cursor")) {
            session.removeMarker(id);
          }
        }
      }
    }

    return () => {
      if (editor && session) {
        const markers = session.getMarkers(true);
        for (let id in markers) {
          if (markers[id].clazz && markers[id].clazz.includes("mock-cursor")) {
            session.removeMarker(id);
          }
        }
      }
    };
  }, [showMockSync, mockConfig, ace]);



  const { isConnected: isWSConnected, activeUsers, sendEdit, otherUsersCursors } = useCollaborativeEditing({
    projectId: projectid,
    fileId: fileId,
    initialContent: toolActualValue,
    onContentUpdate: (newContent) => {
      console.log("onContentUpdate received content length:", newContent?.length);
      // Update editor
      if (aceRef.current?.editor) {
        console.log("Updating Ace editor content...");
        const cursor = aceRef.current.editor.getCursorPosition();
        aceRef.current.editor.setValue(newContent, -1);
        aceRef.current.editor.moveCursorToPosition(cursor);
        setTexFile(newContent);
        setToolActualValue(newContent);
      } else {
        console.warn("Ace editor ref not available!");
      }
    },
    toast,
    enabled: useWebSocket
  });
  console.log("the data we are getting from the useCollborativeEditing is :", isWSConnected, activeUsers, sendEdit);

  useEffect(() => {
    if (!aceRef.current?.editor) return;
    const editor = aceRef.current.editor;
    const session = editor.session;
    const Range = aces.require("ace/range").Range;
    let container = editor.container;
    let positions = container.getBoundingClientRect();
    const width = positions.width;
    const height = positions.height;
    const windowwidth = window.innerWidth;
    console.log("the width and height is :", positions.left, positions.right, width, height, windowwidth);

    const sanitizeForCss = (str) => {
      return str.replace(/[^a-zA-Z0-9_-]/g, '_');
    };

    const existingMarkers = session.getMarkers(true);
    for (let id in existingMarkers) {
      if (existingMarkers[id].clazz?.includes("collab-cursor")) {
        session.removeMarker(id);
      }
    }

    if (Object.keys(otherUsersCursors).length === 0) return;

    const styleId = "collab-cursor-styles";
    let style = document.getElementById(styleId);
    if (!style) {
      style = document.createElement("style");
      style.id = styleId;
      document.head.appendChild(style);
    }


    style.innerHTML = Object.entries(otherUsersCursors)
      .map(([userId, cursor]) => {
        const safeUserId = sanitizeForCss(userId);

        // Vertical: first two rows → show below, else above
        const labelPosition = (cursor.row === 0 || cursor.row === 1)
          ? `bottom: -22px; top: auto;`
          : `top: -22px; bottom: auto;`;

        // Horizontal: get cursor's pixel x position relative to editor
        const screenPos = editor.renderer.textToScreenCoordinates(cursor.row, cursor.col);
        const cursorX = screenPos.pageX - positions.left;
        const estimatedLabelWidth = cursor.label.length * 7 + 20; // ~7px per char + padding
        const isNearRightEdge = (cursorX + estimatedLabelWidth) > width;

        // If near right edge → grow right to left (anchor label's right edge to cursor)
        const horizontalPosition = isNearRightEdge
          ? `right: -2px; left: auto;`
          : `left: -2px; right: auto;`;

        return `
      .collab-cursor-${safeUserId} {
        position: absolute;
        border-left: 2px solid ${cursor.color};
        background-color: ${cursor.color}33;
        z-index: 1000;
      }
      .collab-cursor-${safeUserId}::after {
        content: "${cursor.label}";
        position: absolute;
        ${labelPosition}
        ${horizontalPosition}
        font-size: 10px;
        color: #fff;
        background: ${cursor.color};
        padding: 2px 6px;
        border-radius: 4px;
        white-space: nowrap;
        font-weight: 600;
        pointer-events: none;
        box-shadow: 0 2px 4px rgba(0,0,0,0.2);
      }
    `;
      })
      .join('');
    // Add markers
    Object.entries(otherUsersCursors).forEach(([userId, cursor]) => {
      const safeUserId = sanitizeForCss(userId);
      session.addMarker(
        new Range(cursor.row, cursor.col, cursor.row, cursor.col + 1),
        `collab-cursor-${safeUserId}`,
        "text",
        true
      );
    });

    // Force re-render
    editor.renderer.updateFull();

    return () => {
      // Cleanup on unmount
      const markers = session.getMarkers(true);
      for (let id in markers) {
        if (markers[id].clazz?.includes("collab-cursor")) {
          session.removeMarker(id);
        }
      }
    };
    // }, [otherUsersCursors, aceRef.current?.editor]);
  }, [otherUsersCursors]);

  const stateRef = useRef({ texFile, isDirty, fileId, filename, projectid, useWebSocket, isWSConnected });

  useEffect(() => {
    stateRef.current = { texFile, isDirty, fileId, filename, projectid, useWebSocket, isWSConnected };
  }, [texFile, isDirty, fileId, filename, projectid, useWebSocket, isWSConnected]);

  const [diffList, setDiffList] = useState([]);
  const [toolDiffList, setToolDiffList] = useState({});
  const [popUp, setPopUp] = useState({
    popup: { x: -100, y: -100, show: false, header: "", body: "", type: "" },
  });
  const [loading, setLoading] = useState(true);
  // const [openFiles, setOpenFiles] = useState([]);
  // WebSocket Connection
  useEffect(() => {
    if (file && !props.openFiles.includes(file)) {
      props.setOpenFiles(prev => [...prev, file]);
    }
  }, [file]);

  const closeTab = (e, fileName) => {
    e.stopPropagation();
    const newFiles = props.openFiles.filter(f => f !== fileName);
    props.setOpenFiles(newFiles);

    if (file === fileName) {
      if (newFiles.length > 0) {
        navigate(`/${projectid}/${newFiles[newFiles.length - 1]}`);
      } else {
        props.setOpenFiles(prev => [...prev, Allfiles.data[0].name]);
        navigate(`/${projectid}/${Allfiles.data[0].name}`);
        console.log("the project all data and project id is :", projectid, "the all file is:", Allfiles, "the first file name is :", Allfiles.data[0].name);
        // navigate(`/${projectid}/`);
      }
    }
  };

  const fileStates = useRef({});

  // Save state on file change (cleanup of previous file)
  useEffect(() => {
    return () => {
      // Save cursor and scroll position for the current file before unmounting/switching
      if (aceRef.current?.editor && file) {
        const session = aceRef.current.editor.session;
        fileStates.current[file] = {
          cursor: aceRef.current.editor.getCursorPosition(),
          scrollTop: session.getScrollTop(),
          scrollLeft: session.getScrollLeft()
        };
      }
    };
  }, [file]);

  // Restore state when filename updates (content loaded)
  useEffect(() => {
    // Ensure we have a valid state and editor
    if (filename && fileStates.current[filename] && aceRef.current?.editor) {
      // Timeout to allow Ace to render new text content first
      setTimeout(() => {
        const state = fileStates.current[filename];
        aceRef.current.editor.moveCursorToPosition(state.cursor);
        aceRef.current.editor.session.setScrollTop(state.scrollTop);
        aceRef.current.editor.session.setScrollLeft(state.scrollLeft);
        aceRef.current.editor.clearSelection();
      }, 50);
    }
  }, [filename]);

  const [performancetime, setPerformanceTime] = useState("");
  const [alerttoshow, setAlertToShow] = useState(0);
  const [refreshStyle, setRefreshStyle] = useState(false);
  // const [client, setClient] = useState([])
  const CLIENT_STYLE_MAP = {
    epl: epl,
    edp: edp
  };
  const [client, setClient] = useState(() => {
    try {
      const data = localStorage.getItem("client");
      if (!data) return [];

      const jsondata = JSON.parse(data);
      if (!Array.isArray(jsondata)) return [];

      const projectEntry = jsondata.find(
        entry => entry.id === projectid
      );
      if (!projectEntry) return [];

      const clientKey = projectEntry.clients;
      if (!clientKey) return [];

      return CLIENT_STYLE_MAP[clientKey] || [];
    } catch {
      return [];
    }
  });

  // let alert = 0;
  const corrections = props?.corrections || {};

  const isEditable = !Object.values(corrections).every(
    (val) => Array.isArray(val) ? val.length === 0 : !val
  );





  useEffect(() => {
    if (ace?.current) {
      setupF3Search(ace);
    }

    return () => {
      cleanupF3Search(ace);
    };
  }, [ace?.current]);

  // State to store all project files to avoid re-fetching on every file switch
  useEffect(() => {
    const projectfiles = async () => {
      setLoading(true);
      // Autosave current file before loading new one if dirty
      if (stateRef.current.isDirty && stateRef.current.fileId) {
        await handleSave(true);
      }

      try {
        const files = await get_all_project_file_Api(projectid);
        setAllFiles(files);

        let currentFile = null;
        if (files.data) {
          // console.log(files.data);
          files.data.forEach((item, id) => {
            if (item.name === file) {
              currentFile = item;
              const proofContent = item.proof_content ? item.proof_content : item.content;
              setToolActualValue(item.content)
              setActualValue(proofContent)
              setTexFile(item.content)
              // console.log("the file type is", typeof (item.content))
              //ace?.current?.editor?.setValue(item.content, -1);
              setFilename(item.name)
              setFileID(item.file_uuid || item.id || item.uuid)
              props.setFileName(item.project_name);

            }
          })

          // Parse citations and find unused references
          try {
            const parserResults = FileParser(files, ace);
            // console.log("Parser Results:", parserResults);

            if (parserResults.unusedReferences?.length > 0) {
              // console.log("⚠️ Unused references found:");
              // parserResults.unusedReferences.forEach(ref => {
              //   console.log(`  - ${ref.key} at row ${ref.row}`);
              // });

              if (currentFile?.name === "Reference.tex") {
                // insertUnusedReferenceQueries(parserResults, ace, currentFile.name, props.querydata);
              }
            }
          } catch (parserError) {
            console.error("FileParser error:", parserError);
          }
        } else {
          toast({
            title: "Error",
            description: "No such project found",
            status: "error",
            duration: 2000,
            isClosable: "true"
          })
          navigate("/dashboard/myprojects");
        }
      } catch (error) {
        setTexFile("No Files Found")
        setLoading(false)
      } finally {
        setLoading(false)
      }
      setTimeout(() => {
        // enableMarkers();
        aceRef.current?.editor?.session.getUndoManager().reset();
      }, 2000);
    }
    projectfiles();
    if (aceRef.current && aceRef.current.editor) {
      aceRef.current.editor.setOption("enableMultiselect", false);
    }

  }, [aceRef, file])

  console.log("all the states are ", props.states)


  useEffect(() => {
    if (performancetime > 50 && alerttoshow < 1) {
      onalertToogle()
      setAlertToShow(1)
    }
  }, [performancetime])

  useEffect(() => {
    if (!props.isChecked) {
      onChange(texFile);

      props.uploadtex(texFile);
    }

  }, [actualValue, texFile]);




  // useEffect(() => {
  //   props.StopLoading();
  //   let styles = [];
  //   let client = "common";
  //   const projectName = props.projectDetails?.name?.toLowerCase() || "";
  //   const isInternal = props.projectDetails?.is_internal;

  //   let defaultStyles = [];
  //   if (isInternal && projectName.startsWith("epl")) {
  //     client = "epl";
  //     defaultStyles = Object.keys(epl);
  //   } else if (isInternal && projectName.startsWith("edp")) {
  //     client = "edp";
  //     defaultStyles = Object.keys(edp);
  //   } else {
  //     client = "common";
  //     defaultStyles = [...new Set(Object.keys({ ...eplStyles, ...edp, ...epl }))];
  //   }

  //   console.log("the selected styles are :", defaultStyles);

  //   const selectedData = localStorage.getItem("selectedStyles");
  //   const selectedJson = selectedData ? JSON.parse(selectedData) : null;
  //   console.log("the selectedJson is:", selectedJson);
  //   const selectedEntry = Array.isArray(selectedJson)
  //     ? selectedJson.find((entry) => entry.id === projectid)
  //     : null;

  //   if (selectedEntry && Array.isArray(selectedEntry.selectedStyles) && selectedEntry.selectedStyles.length > 0) {
  //     styles = selectedEntry.selectedStyles;
  //   } else {
  //     const dashboardData = localStorage.getItem("client");
  //     const dashboardJson = dashboardData ? JSON.parse(dashboardData) : null;
  //     const projectEntry = Array.isArray(dashboardJson)
  //       ? dashboardJson.find((entry) => entry.id === projectid)
  //       : null;
  //     styles = (projectEntry?.styles?.length > 0) ? projectEntry.styles : defaultStyles;
  //   }

  //   if (!texFile) return;

  //   // ── Increment generation counter — any currently running job is now stale ──
  //   const myGeneration = ++suggestionGenRef.current;

  //   const timer = setTimeout(async () => {
  //     // ── After debounce delay, verify we're still the latest keystroke ──
  //     if (myGeneration !== suggestionGenRef.current) return;

  //     console.log("Debounce: Running AutoSuggestion...");
  //     JumpFunctionality(ace, toast);
  //     setupLatexAutocomplete(ace);
  //     querySelector(ace, props);
  //     console.log("the styles to autosuggestion is :",styles);
  //     await AutoSuggestion(texFile,ace,styles,client,props,setTexFile,filename,Allfiles.data,myGeneration,suggestionGenRef);
  //   }, 800);

  //   return () => clearTimeout(timer);

  // }, [texFile, props.showSuggestion, props.view, props.showautosuggestion, props.projectDetails]);

  useEffect(() => {
    props.StopLoading();
    let styles = [];
    let client = "common"; // Default fallback
    const projectName = props.projectDetails?.name?.toLowerCase() || "";
    const isInternal = props.projectDetails?.is_internal;

    // ── 1. Fetch all tool data from LocalStorage ──
    const peDataRaw = localStorage.getItem("peTools");
    const ceDataRaw = localStorage.getItem("ceTools");
    const stylingDataRaw = localStorage.getItem("stylingTools");

    const peJson = peDataRaw ? JSON.parse(peDataRaw) : null;
    const ceJson = ceDataRaw ? JSON.parse(ceDataRaw) : null;
    const stylingJson = stylingDataRaw ? JSON.parse(stylingDataRaw) : null;

    // ── 2. Determine which tool is Active and get its styles ──
    if (peJson?.activestatus) {
      console.log("acutally PEtool is running")
      client = "PeToolsStyles";
      const projectEntry = peJson.projects?.find(p => p.id === projectid);
      styles = projectEntry?.styles || [];

    } else if (ceJson?.activestatus) {
      client = "CeToolStyles";
      const projectEntry = ceJson.projects?.find(p => p.id === projectid);
      styles = projectEntry?.styles || [];

    } else if (stylingJson?.activestatus) {
      // Logic for Styling Tools
      client = isInternal && projectName.startsWith("epl") ? "epl" :
        isInternal && projectName.startsWith("edp") ? "edp" : "common";

      const projectEntry = stylingJson.projects?.find(p => p.id === projectid);
      styles = projectEntry?.selectedStyles || [];

    } else {
      // ── 3. FALLBACK: Default behavior if no tool is explicitly active ──
      let defaultStyles = [];
      if (isInternal && projectName.startsWith("epl")) {
        client = "epl";
        defaultStyles = Object.keys(epl);
      } else if (isInternal && projectName.startsWith("edp")) {
        client = "edp";
        defaultStyles = Object.keys(edp);
      } else {
        client = "common";
        defaultStyles = [...new Set(Object.keys({ ...eplStyles, ...edp, ...epl }))];
      }

      const dashboardData = localStorage.getItem("client");
      const dashboardJson = dashboardData ? JSON.parse(dashboardData) : null;
      const projectEntry = Array.isArray(dashboardJson)
        ? dashboardJson.find((entry) => entry.id === projectid)
        : null;

      styles = (projectEntry?.styles?.length > 0) ? projectEntry.styles : defaultStyles;
    }

    // ── 4. Run Suggestion Engine ──
    if (!texFile) return;
    const myGeneration = ++suggestionGenRef.current;

    const timer = setTimeout(async () => {
      if (myGeneration !== suggestionGenRef.current) return;

      console.log(`Running AutoSuggestion for client: ${client}`, styles);
      JumpFunctionality(ace, toast);
      setupLatexAutocomplete(ace, false);
      querySelector(ace, props);

      await AutoSuggestion(
        texFile,
        aceRef,
        styles,
        client,
        props,
        setTexFile,
        filename,
        Allfiles.data,
        myGeneration,
        suggestionGenRef
      );
    }, 800);

    return () => clearTimeout(timer);

  }, [texFile, props.showSuggestion, props.view, props.showautosuggestion, props.projectDetails, props.triggerToolStyles]);

  // sending ref from child to parent component
  useImperativeHandle(ref, () => ({
    editor: aceRef?.current?.editor,
  }));

  // useeffect to scrolltoline in PE/CE Tools;

  useEffect(() => {
    if (props.selection) {
      let start = props.selection.start;
      aceRef.current.editor.session.selection.setSelectionRange(props.selection);
      aceRef.current.editor.scrollToLine(start.row);
    }
  }, [props.selection]);

  // useeffect for showing deleted text on hover

  useEffect(() => {
    let editor = aceRef.current;
    if (changes) {
      editor?.editor?.on("mousemove", (e) => showDeletedOnHover(e, changes, setPopUp, popUp, hidePopover));
    }
    return () => {
      if (editor) {
        editor?.editor?.off("mousemove", showDeletedOnHover);
      }
    };
  }, [changes, popUp]);

  // use effect for showing the markers on selection
  useEffect(() => {
    let editor = aceRef.current;
    if (markers) {
      editor?.editor?.on("mouseup", (e) => processSelection(e, hidePopover, markers, bibitems, setPopUp, ImagePopup, CitationPopup, toast, MathPopup, equations, props, tables));
    }
    return () => {
      if (editor) {
        editor?.editor?.off("mouseup", processSelection);
      }
    };
  }, [markers]);

  // ── AI Seamless Edits ──────────────────────────────────────────────────
  const [aiMarker, setAiMarker] = useState(null);
  const [toolbarPos, setToolbarPos] = useState(null);

  useEffect(() => {
    if (props.pendingAIEdit && aceRef.current?.editor) {
      const editor = aceRef.current.editor;
      const session = editor.session;
      const { range, suggestionText } = props.pendingAIEdit;

      const Range = aces.require('ace/range').Range;
      const aceRange = new Range(range.start.row, range.start.column, range.end.row, range.end.column);

      // 1. Scroll and select
      editor.scrollToLine(range.start.row, true, true);

      // 2. Clear old marker if any
      if (aiMarker) session.removeMarker(aiMarker);

      // 3. Add background marker for visual feedback
      const markerId = session.addMarker(aceRange, styles["ai-pending-marker"] || "ai-pending-marker", "background");
      setAiMarker(markerId);

      // 4. Calculate toolbar position (approx top of selection)
      const coords = editor.renderer.textToScreenCoordinates(range.start.row, range.start.column);
      const editorRect = editor.container.getBoundingClientRect();

      setToolbarPos({
        top: coords.pageY - editorRect.top - 40, // 40px above
        left: Math.max(0, coords.pageX - editorRect.left)
      });
    } else {
      if (aiMarker && aceRef.current?.editor) {
        aceRef.current.editor.session.removeMarker(aiMarker);
        setAiMarker(null);
      }
      setToolbarPos(null);
    }
  }, [props.pendingAIEdit]);

  const handleAIAccept = () => {
    if (!props.pendingAIEdit || !aceRef.current?.editor) return;
    const { id, range, suggestionText } = props.pendingAIEdit;
    const editor = aceRef.current.editor;

    // Use standard suggestion logic if possible
    const suggestionItem = props.autoSuggestions?.find(s => s.id === id);
    if (suggestionItem) {
      acceptItem(editor, suggestionItem, props.setTextFile, props);
    } else {
      const Range = aces.require('ace/range').Range;
      const aceRange = new Range(range.start.row, range.start.column, range.end.row, range.end.column);
      editor.session.replace(aceRange, suggestionText);
    }

    props.setPendingAIEdit(null);
    setAiMarker(null);
    toast({ title: "AI Edit Accepted", status: "success", duration: 2000 });
  };

  const handleAIReject = () => {
    if (!props.pendingAIEdit) return;
    const { id } = props.pendingAIEdit;

    const suggestionItem = props.autoSuggestions?.find(s => s.id === id);
    if (suggestionItem) {
      rejectItem(aceRef.current.editor, suggestionItem, props);
    }

    props.setPendingAIEdit(null);
    setAiMarker(null);
    setToolbarPos(null);
  };

  useEffect(() => {
    document.addEventListener("keydown", function (event) {
      if (event.ctrlKey && event.key === "T") {
        event.preventDefault();
      }
    });
  }, []);

  useEffect(() => {
    //  Ace prompt
    if (!aceRef.current?.editor) return;
    const observer = new MutationObserver(() => {
      const promptBox = document.querySelector(".ace_prompt_container");
      const aceContainer = document.querySelector(".ace");
      const promptContainer = document.querySelector(".promptContainer");
      //console.log(aceContainer);
      //console.log(promptContainer.parentElement);
      if (promptBox && aceContainer) {
        // Calculate the editor's position on the screen
        const rect = aceContainer.getBoundingClientRect();

        // Apply custom styling and position it RELATIVE to the editor's screen position
        promptBox.style.position = "fixed"; // Fixed to screen coordinates
        promptBox.style.zIndex = 9999;
        promptBox.style.left = `${rect.right - 260}px`; // 260px wide approx
        promptBox.style.top = `${rect.top + 10}px`;
        promptBox.style.background = "#F5F5F5";
        promptBox.style.border = "1px solid #CCC";
        promptBox.style.borderRadius = "8px";
        promptBox.style.boxShadow = "0 8px 24px rgba(0,0,0,0.15)";
        promptBox.style.padding = "12px";
        promptBox.style.width = "240px";

        const input = promptBox.querySelector("input.ace_search_field, input");
        if (input) {
          input.style.padding = "8px 12px";
          input.style.borderRadius = "4px";
          input.style.border = "1px solid #ddd";
          input.style.fontSize = "14px";
          input.style.width = "100%";
          input.style.outline = "none";
        }

        const history = promptBox.querySelector(".ace_autocomplete");
        if (history) history.remove();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    aceShortcuts(aceRef, props, () => { handleSave(false) });
    const editor = aceRef.current?.editor;
    if (editor) {
      editor.commands.addCommand({
        name: "wildcardSearch",
        bindKey: { win: "Ctrl-Shift-F", mac: "Command-Shift-F" },
        exec: () => setWildcardOpen((prev) => !prev),
      });
    }
  }, []);




  // useeffect for searching the text in pdf on selection in editor
  useEffect(() => {
    let curSearch = props.latexsearch;
    if (curSearch && curSearch.length > 3 && curSearch !== lastSearch) {
      setSearchFromPdf(curSearch);
      setLastSearch(curSearch);
    }
  }, [props.latexsearch, lastSearch]);

  // function to search the text on editor on selection in pdf
  const setSearchFromPdf = (search) => {
    aceRef.current.editor.find(search);
  };


  // function to hidepopups
  //MARK:Hidepopover
  const hidePopover = () => {
    setPopUp({ popup: { show: false } });
  };

  // function to enable markers in ace editor
  const enableMarkers = (content = texFile) => {
    if (content) {
      setBibitems(getAllBibitems(content));
      setEquations(getAllEquations(content));
      setTables(getAllTables(content));
    }
    // getAllBibitems(texFile);
    if (aceRef?.current?.editor) {
      var markers = getCitationMarkers(styles, aceRef);
      var inlineEqnMarkers = getInlineEqnMarkers(aceRef, styles);
      var eqnMarkers = getEqnMarkers(aceRef, styles);
      var allMarkers = [].concat(
        inlineEqnMarkers,
        eqnMarkers,
        markers
      );
    }
    setMarkers(allMarkers);
    // querySelector(aceRef, props);
  };

  // function to compare changes in the tex file and actual file.
  const onChange = (newValue) => {
    // If WS is enabled and connected, strictly don't use 'isDirty' for autosave delay
    // Instead send immediately (or debounced inside hook if we wanted, but here immediately)
    if (useWebSocket && isWSConnected) {
      sendEdit(newValue);
      // We don't set setIsDirty(true) because we are sending it continuously 
      // and we don't want the interval saver to interfere.
      // However, we still might want to track unsaved status if it fails? 
      // For now, let's assume real-time.
    } else {
      setIsDirty(true);
    }

    setTexFile(newValue);
    setTimeout(() => {
      updateSpellingStats();
    }, 100);
    setCheck(true);

    if (changeTimeoutRef.current) {
      clearTimeout(changeTimeoutRef.current);
    }

    changeTimeoutRef.current = setTimeout(() => {
      if (toggleChange && newValue) {
        let start = performance.now();
        let dmp = new diff_match_patch();
        var r = dmp.diff_main(actualValue, newValue);
        let allMarkers = [];
        var st = 0;
        setDiffList(r);
        for (var j = 0; j < r.length; j++) {
          var i = r[j];
          if (i[0] === 1) {
            let value = i[1];
            let startPos = aceRef.current.editor.session.doc.indexToPosition(st);
            let endPos = aceRef.current.editor.session.doc.indexToPosition(st + value.length);
            allMarkers.push({
              startRow: startPos.row,
              startCol: startPos.column,
              endRow: endPos.row,
              endCol: endPos.column,
              startIndex: st,
              endIndex: endPos,
              className: styles.added_marker,
              type: "text",
              text: value,
              mode: "added",
              index: j
            });
            st = st + value.length;
          } else if (i[0] === -1) {
            let value = i[1];
            let startPos = aceRef.current.editor.session.doc.indexToPosition(st);
            let endPos = aceRef.current.editor.session.doc.indexToPosition(st);
            allMarkers.push({
              startRow: startPos.row,
              startCol: startPos.column,
              endRow: endPos.row,
              endColumn: endPos.column,
              startIndex: st,
              endIndex: endPos,
              className: styles.deleted_marker,
              type: "background",
              text: value,
              mode: "deleted",
              index: j
            });
          } else {
            st = st + i[1].length;
          }
        }
        let end = performance.now();
        setChanges(allMarkers);
        props.exampleAction(allMarkers);
        setPerformanceTime(end - start);
      }
      enableMarkers(newValue);
    }, 400);

    return true;
    // } catch (e) {
    //   alert("Problem with file, Please check")
    // }
  };

  const AceDocumentRef = useRef(null);

  useEffect(() => {
    if (aceRef.current?.editor) {
      setupLatexAutocomplete(aceRef);
    }
  }, [aceRef, texFile]); // Run when editor or content changes to keep completers locked

  useEffect(() => {
    if (!aceRef.current?.editor) return;

    // Give Ace a tick to load its modules
    setTimeout(() => {
      let DocConstructor = null;

      if (window.ace && window.ace.require) {
        DocConstructor = window.ace.require("ace/document").Document;
      } else if (window.acequire) {
        DocConstructor = window.acequire("ace/document").Document;
      }

      if (!DocConstructor) {
        console.error("Ace Document could not be loaded — check your ace setup.");
        return;
      }

      AceDocumentRef.current = DocConstructor;
    }, 0);
  }, [ace]);

  // console.log("updateCorrections changed:", props.updateCorrections);

  // // function to insert Math equations in texfile
  const insertMath = (text) => {
    aceRef.current?.editor?.session.insert(
      aceRef.current?.editor?.getCursorPosition(),
      text
    );
  };
  // const triggerMath = () => insertMath();//for button

  // function to save texfile
  // Unified Save Function (handles both manual and auto save)
  async function handleSave(isAuto = false) {
    const current = stateRef.current;

    // Auto-save checks
    if (isAuto && !current.isDirty) return;
    if (isAuto && !current.fileId) return;

    // Manual Save checks
    if (!isAuto && (!current.fileId || current.fileId === "")) {
      props.toast({ title: "Error: Missing File ID", status: "error" });
      return;
    }

    setIsSaving(true);

    // WebSocket Save
    if (current.useWebSocket && current.isWSConnected) {
      // sendEdit from hook is stable
      const success = sendEdit(current.texFile);
      if (success) {
        setIsDirty(false);
        if (!isAuto) {
          props.toast({ title: "Tex saved (WS).", status: "success", duration: 1000 });
        }
        setTimeout(() => setIsSaving(false), 500);
        return;
      }
    }

    // HTTP Fallback
    try {
      const result = await update_project_file_Api(
        current.projectid,
        current.fileId,
        current.filename,
        current.texFile
      );
      if (result.data) {
        setIsDirty(false);
        if (!isAuto) {
          props.toast({ title: "Tex saved.", status: "success", duration: 1000 });
        }
      }
    } catch (e) {
      console.error("Save failed", e);
      if (!isAuto) props.toast({ title: "Save failed", status: "error" });
    } finally {
      setTimeout(() => setIsSaving(false), 500);
    }
  };

  const AutoCorrect = () => {
    toast({ title: "Feature yet to be Implemented" });
  };



  useEffect(() => {
    const editor = aceRef.current?.editor;
    if (!editor) return;
    if (!editor.getReadOnly()) return; // attach only if read-only

    const handleKeyDown = (e) => {
      if (e.key.length === 1) {
        e.preventDefault();
        suggestToggle();
        // await handleSave(true);
      }
    };

    const container = editor.container;
    container.addEventListener("keydown", handleKeyDown);

    return () => {
      container.removeEventListener("keydown", handleKeyDown);
    };
  }, [aceRef.current?.editor?.getReadOnly?.()]);


  aceRef.current?.editor?.setOptions({
    fontFamily: "Fira Code, monospace",
    fontSize: "18px"
  });



  const isPdfOrImage = filename && (
    filename.toLowerCase().endsWith('.pdf') ||
    filename.match(/\.(jpg|jpeg|png|gif|svg|webp|eps)$/i)
  );

  // Tab switching with autosave
  const handleTabSwitch = async (fileName) => {
    const { isDirty } = stateRef.current;
    if (fileName === file) return;

    if (isDirty) {
      await handleSave(true);
    }
    navigate(`/${projectid}/${fileName}`);
  };

  //MARK:Rendering part
  return (
    <>
      <div className="ace" style={styles.ace_editor}>
        <span>
          {/* Tab Bar */}
          <Box
            display="flex"
            alignItems="center"
            overflowX="auto"
            bg="#252526"
            h="35px"
            borderBottom="1px solid #1e1e1e"
          >
            {props.openFiles.map((fileName, idx) => {
              const isActive = fileName === file;
              return (
                <Box
                  key={idx}
                  onClick={() => handleTabSwitch(fileName)}
                  cursor="pointer"
                  bg={isActive ? "#1e1e1e" : "#2d2d2d"}
                  color={isActive ? "#fff" : "#969696"}
                  h="100%"
                  minW="120px"
                  maxW="200px"
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  px={3}
                  borderRight="1px solid #252526"
                  borderTop={isActive ? "1px solid #007fd4" : "1px solid transparent"}
                  _hover={{ bg: isActive ? "#1e1e1e" : "#2a2d2e" }}
                >
                  <Box display="flex" alignItems="center" overflow="hidden">
                    <VscFileCode color={isActive ? "#519aba" : "#969696"} size="14px" style={{ flexShrink: 0, marginRight: "6px" }} />
                    <Text fontSize="13px" isTruncated fontFamily="'Segoe UI', sans-serif">{fileName}</Text>
                  </Box>
                  <Box
                    as="span"
                    ml={2}
                    onClick={(e) => closeTab(e, fileName)}
                    opacity={isActive ? 1 : 0}
                    _hover={{ bg: "#4a4a4a", borderRadius: "3px", color: "white" }}
                    p="2px"
                    sx={{
                      ".chakra-icon": { display: "block" },
                      "&:hover": { opacity: 1 },
                      "ancestor:hover &": { opacity: 1 } // Trying to show on tab hover
                    }}
                  >
                    <VscClose size="14px" />
                  </Box>
                </Box>
              );
            })}
          </Box>

          {loading && (
            <Box
              position="absolute"
              top="35px"
              left="0"
              w="100%"
              h="calc(100% - 35px)"
              zIndex="999"
              bg={customtheme === "dark" || customtheme === "black" ? "rgba(0,0,0,0.6)" : "rgba(255,255,255,0.9)"}
              display="flex"
              justifyContent="center"
              alignItems="center"
              backdropFilter="blur(2px)"
            >
              <Spinner thickness='4px' speed='0.65s' emptyColor='gray.200' color='blue.500' size='xl' />
            </Box>
          )}

          {isPdfOrImage ? (
            <Box height="calc(90vh - 35px)" position="relative" bg="#1e1e1e">
              <FileViewer projectId={projectid} file={{ name: filename, file_uuid: fileId }} />
            </Box>
          ) : (
            <>
              <HStack
                backgroundColor="var(--editor-bg)"
                justifyContent="space-between"
                maxH="36px"
                minH="36px"
              >
                <ButtonGroup spacing="1" alignItems={"center"}>

                  {props.leftController ? (
                    <Tooltip label="Close panel">
                      <IconButton
                        onClick={() => {
                          props.toggleLeftPanel();
                        }}
                        size="lg"
                        colorScheme="var(--editor-bg)"
                        aria-label="Close Left Panel"
                        style={{ minWidth: '2rem', height: '2rem' }}
                        icon={<MenuClose />}
                        _hover={{ bg: "var(--editor-hover)" }}
                      />
                    </Tooltip>
                  ) : (
                    <Tooltip label="Open panel">
                      <IconButton
                        onClick={() => {
                          props.toggleLeftPanel();
                        }}
                        size="md"
                        colorScheme="var(--editor-bg)"
                        aria-label="Open Left Panel"
                        style={{ minWidth: '2rem', height: '2rem' }}
                        icon={<MenuBar />}
                        _hover={{ bg: "var(--editor-hover)" }}
                      />
                    </Tooltip>
                  )}
                  <Tooltip label="Undo">
                    <IconButton
                      onClick={() => aceRef.current.editor.undo()}
                      size="md"
                      colorScheme="var(--editor-bg)"
                      aria-label="Search inside document"
                      style={{ minWidth: '2rem', height: '2rem' }}
                      icon={<Undo />}
                      _hover={{ bg: "var(--editor-hover)" }}
                    />
                  </Tooltip>

                  <Tooltip label="Redo">
                    <IconButton
                      onClick={() => aceRef.current.editor.redo()}
                      size="md"
                      colorScheme="var(--editor-bg)"
                      aria-label="Search inside document"
                      style={{ minWidth: '2rem', height: '2rem' }}
                      icon={<Redo />}
                      _hover={{ bg: "var(--editor-hover)" }}
                    />
                  </Tooltip>

                  <Box
                    height="34px"
                    width="1px"
                    bgGradient="linear(to-b, transparent, white, transparent)"
                    mx={2}
                    alignSelf="center"
                  />

                  <Tooltip label="Search">
                    <IconButton
                      onClick={() => aceRef.current.editor.execCommand("find")}
                      size="md"
                      colorScheme="var(--editor-bg)"
                      aria-label="Search inside document"
                      style={{ minWidth: '2rem', height: '2rem' }}
                      icon={<SearchIcon />}
                      _hover={{ bg: "var(--editor-hover)" }}
                    />
                  </Tooltip>



                  <Tooltip label="Text to Bold">
                    <IconButton
                      onClick={() => textToBold(aceRef)}
                      size="lg"
                      colorScheme="var(--editor-bg)"
                      aria-label="Text to Bold"
                      style={{ minWidth: '2rem', height: '2rem' }}
                      icon={<BoldIcon />}
                      _hover={{ bg: "var(--editor-hover)" }}
                    />
                  </Tooltip>
                  <Tooltip label="Text to Italic">
                    <IconButton
                      onClick={() => textToItalics(aceRef)}
                      fontSize="l"
                      size="lg"
                      colorScheme="var(--editor-bg)"
                      aria-label="Text to Italic"
                      style={{ minWidth: '2rem', height: '2rem' }}
                      icon={<ItalicIcon />}
                      _hover={{ bg: "var(--editor-hover)" }}
                    />
                  </Tooltip>

                  <Box
                    height="34px"
                    width="1px"
                    bgGradient="linear(to-b, transparent, white, transparent)"
                    mx={2}
                    alignSelf="center"
                  />

                  <Tooltip label="Replace">
                    <IconButton
                      id="replace"
                      onClick={() => aceRef.current.editor.execCommand("replace")}
                      color="white"
                      size="lg"
                      colorScheme="var(--editor-bg)"
                      aria-label="Replace inside document"
                      style={{ minWidth: '2rem', height: '2rem' }}
                      icon={<ReplaceIcon />}
                      _hover={{ bg: "var(--editor-hover)" }}
                    />
                  </Tooltip>
                  <Tooltip label="Wildcard Search">
                    <IconButton
                      onClick={() => setWildcardOpen((prev) => !prev)}
                      size="md"
                      colorScheme="var(--editor-bg)"
                      aria-label="Wildcard search"
                      style={{ minWidth: "2rem", height: "2rem" }}
                      icon={
                        /* Simple * icon — swap for any icon you like */
                        <span style={{ fontWeight: 800, fontSize: "15px", fontFamily: "monospace" }}>
                          *?
                        </span>
                      }
                      bg={wildcardOpen ? "var(--editor-hover)" : undefined}
                      _hover={{ bg: "var(--editor-hover)" }}
                    />
                  </Tooltip>

                  <InsertMath insertMath={insertMath} />


                  <Tooltip label="SpellCheck">
                    <IconButton
                      onClick={AutoCorrect}
                      size="lg"
                      colorScheme="var(--editor-bg)"
                      aria-label="Autocorrect"
                      style={{ minWidth: '2rem', height: '2rem' }}
                      icon={<Auto />}
                      _hover={{ bg: "var(--editor-hover)" }}
                    />
                  </Tooltip>

                  <Box
                    height="34px"
                    width="1px"
                    bgGradient="linear(to-b, transparent, white, transparent)"
                    mx={2}
                    alignSelf="center"
                  />

                  <Tooltip label="Use WebSocket (Experimental)">
                    <Box display="flex" gap={2} alignItems="center">
                      <Switch
                        aria-label="Use WebSocket experimental feature"
                        isChecked={useWebSocket}
                        onChange={() => setUseWebSocket(!useWebSocket)}
                        size="md"
                        colorScheme="green"
                        sx={{
                          ".chakra-switch__track": {
                            bg: useWebSocket ? "green.500" : "gray.300",
                          }
                        }}
                      />
                      <p style={{ color: "#fff", fontWeight: "500", fontSize: "12px", whiteSpace: "nowrap" }}>WS Saver</p>
                    </Box>
                  </Tooltip>

                  <Box
                    height="34px"
                    width="1px"
                    bgGradient="linear(to-b, transparent, white, transparent)"
                    mx={2}
                    alignSelf="center"
                  />



                  <Tooltip label="Show/Hide Changes">
                    <Box display="flex" gap={2} alignItems="center">
                      <Switch
                        aria-label="Show or hide corrections"
                        isChecked={toggleChange}
                        onChange={() => {
                          setToggleChange(!toggleChange);
                          onChange(texFile);
                        }}
                        size="md"
                        sx={{
                          // Track styles
                          ".chakra-switch__track": {
                            bg: "white",
                            border: "2px solid var(--editor-bg)",
                            _checked: {
                              bg: "white",
                            },
                          },
                          // Thumb styles
                          ".chakra-switch__thumb": {
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            position: "relative",
                            bg: toggleChange ? "var(--editor-bg)" : "#D2CFCE",
                            _after: {
                              content: 'url("/images/Redesignpics/tick.svg")',
                              fontSize: "18px",
                              color: "white",
                              opacity: toggleChange ? 1 : 0,
                              transition: "opacity 0.2s ease",
                            },
                          },
                        }}
                      />

                      <p style={{ color: "#fff", fontWeight: "500" }}>Corrections</p>
                    </Box>
                  </Tooltip>
                  {/* <Tooltip label="ReStyle">
                    <IconButton
                      id="refresh"
                      // onClick={() => { setRefreshStyle(prev => !prev); refreshStyles(); }}
                      onClick={() => {

                        props.onIsChecked();
                        props.showsuggestion(); navigate("#suggestions"); props.control((prevState) => ({
                          ...prevState,
                          view: "suggestions",
                        }));
                      }}
                      // onClick={() => { loadSuggestion() }}
                      color="white"
                      size="lg"
                      colorScheme="var(--editor-bg)"
                      aria-label="Refresh Styles"
                      icon={<RefreshIcon />}
                      _hover={{ bg: "var(--editor-hover)" }}
                    />
                  </Tooltip> */}

                  {/* <Tooltip label="Convert US,UK">
                    <IconButton
                      onClick={onOpen}
                      size="lg"
                      colorScheme="var(--editor-bg)"
                      aria-label="Convert US,UK"
                      style={{ minWidth: '2rem', height: '2rem' }}
                      icon={<Langchange />}
                      _hover={{ bg: "var(--editor-hover)" }}
                    />
                  </Tooltip> */}





                  {activeUsers.length > 0 && (
                    <Box display="flex" ml={2} alignItems="center">
                      <Text color="gray.400" fontSize="xs" mr={1}>Online:</Text>
                      <Box display="flex" gap="-5px">
                        {activeUsers.map((u, i) => (
                          <Tooltip key={u.id || i} label={u.name || u.email}>
                            <Box
                              w="24px" h="24px"
                              borderRadius="full"
                              bg={["red.500", "blue.500", "green.500", "purple.500"][i % 4]}
                              color="white"
                              display="flex" alignItems="center" justifyContent="center"
                              fontSize="xs"
                              border="2px solid var(--editor-bg)"
                              ml={i > 0 ? "-8px" : 0}
                            >
                              {u.name ? u.name[0].toUpperCase() : "?"}
                            </Box>
                          </Tooltip>
                        ))}
                      </Box>
                    </Box>
                  )}

                </ButtonGroup>
                {/* test */}

                <ButtonGroup backgroundColor="var(--editor-bg)" display={"flex"} alignItems={"center"} position={"absolute"} right={0} >

                  <Tooltip label="Save">
                    <Box as="button" onClick={() => handleSave(false)} background={"#FFF"} display={"flex"} alignItems={"center"} py={0} pr={3} mr={3} borderRadius={"8px"} marginRight={"auto"}>
                      <IconButton
                        size="lg"

                        colorScheme="var(--editor-bg)"
                        aria-label="Save Tex File"
                        icon={isSaving ? (
                          <Spinner size="xs" color="var(--editor-bg)" speed="0.65s" thickness="2px" />
                        ) : (
                          <svg width="18" color="var(--editor-bg)" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_598_355)">
                              <path d="M4.5 3H12L15 6V13.5C15 13.8978 14.842 14.2794 14.5607 14.5607C14.2794 14.842 13.8978 15 13.5 15H4.5C4.10218 15 3.72064 14.842 3.43934 14.5607C3.15804 14.2794 3 13.8978 3 13.5V4.5C3 4.10218 3.15804 3.72064 3.43934 3.43934C3.72064 3.15804 4.10218 3 4.5 3Z" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M7.5 10.5C7.5 10.8978 7.65804 11.2794 7.93934 11.5607C8.22064 11.842 8.60218 12 9 12C9.39782 12 9.77936 11.842 10.0607 11.5607C10.342 11.2794 10.5 10.8978 10.5 10.5C10.5 10.1022 10.342 9.72064 10.0607 9.43934C9.77936 9.15804 9.39782 9 9 9C8.60218 9 8.22064 9.15804 7.93934 9.43934C7.65804 9.72064 7.5 10.1022 7.5 10.5Z" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M10.5 3V6H6V3" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
                            </g>
                            <defs>
                              <clipPath id="clip0_598_355">
                                <rect width="18" height="18" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        )}
                        height={"fit-content"}
                        minHeight="48px"
                        minWidth="48px"
                        p={2}
                        m={[2, -2]}
                      // _hover={{ bg: "var(--editor-hover)" }}
                      />
                      <Text style={{ color: "var(--editor-bg)", fontWeight: "500" }}>{isSaving ? "Saving..." : "Save"}</Text>
                    </Box>
                  </Tooltip>

                  <Box>
                    {props.pdfviewer ? (
                      <Tooltip label="Expand Editor">
                        <IconButton
                          onClick={() => {
                            props.togglePDF();
                          }}
                          size="md"
                          colorScheme="var(--editor-bg)"
                          aria-label="toogle-pdf"
                          style={{ minWidth: '2rem', height: '2rem' }}
                          // position="absolute"
                          right="0"
                          z-index="2"
                          bg="var(--editor-bg)"
                          icon={<Resize1 />}
                          _hover={{ bg: "var(--editor-hover)" }}
                        ></IconButton>
                      </Tooltip>
                    ) : (
                      <Tooltip label="Minimise editor">
                        <IconButton
                          onClick={() => {
                            props.togglePDF();
                          }}
                          size="md"
                          // position="absolute"
                          right="15px"
                          colorScheme="var(--editor-bg)"
                          aria-label="toogle-pdf"
                          style={{ minWidth: '2rem', height: '2rem', marginLeft: '15px' }}
                          icon={<Resize2 />}
                          _hover={{ bg: "var(--editor-hover)" }}
                        ></IconButton>
                      </Tooltip>
                    )}
                  </Box>
                </ButtonGroup>
              </HStack>

              <PopOver state={popUp} onClick={() => hidePopover()} />

              <Modal isOpen={alertOpen} onClose={onalertClose} isCentered>
                <ModalOverlay>
                  <ModalContent>
                    <ModalHeader>
                      Alert
                    </ModalHeader>
                    <ModalCloseButton />
                    <ModalBody overflow="auto" padding="20px">
                      <Box>
                        <p>
                          Corrections on the file is too high please disable the Real Time Diff functionality to have a smooth editing experience.
                        </p>
                      </Box>
                      <Box mt="15px">
                        <Button onClick={() => { setToggleChange(false); onalertClose() }}> Turn off Real Time Diff </Button>
                      </Box>
                    </ModalBody>
                  </ModalContent>
                </ModalOverlay>
              </Modal>
              {/* <ReusableModal
            isOpen={suggestOpen}
            onClose={suggestClose}
            title="Alert"
            footerButtons={[
              { label: "Close", closeOnClick: true }
            ]}
          >
            <p style={{ fontSize: "18px" }}>Please clear all suggestions to continue editing.</p>
          </ReusableModal> */}
              {/*MARK:Ace Setup*/}
              <Box position="relative" width="100%" height="calc(92vh - 34px - 35px)">
                <WildcardSearch
                  aceRef={aceRef}
                  isOpen={wildcardOpen}
                  onClose={() => setWildcardOpen(false)}
                />
                <AceEditor
                  // onMouseMove={showDeletedOnHover}

                  fontSize={18}
                  ref={aceRef}
                  markers={(toggleChange ? (markers || []).concat(changes || []) : (markers || []))}
                  mode="latex"
                  theme={customtheme == "dark" ? "dracula" : customtheme == "black" ? "terminal" : "xcode"}
                  name="ace_editor"
                  wrapEnabled={true}
                  editorProps={{ $blockScrolling: true }}
                  options={{
                    enableMultiselect: false,
                    enableBasicAutocompletion: true,
                    enableLiveAutocompletion: true,
                    enableSnippets: false
                  }}
                  readOnly={isEditable}
                  onChange={onChange}
                  value={texFile}
                  enableBasicAutocompletion={true}
                  enableLiveAutocompletion={true}
                  onLoad={(editor) => {
                    editorRef.current = editor;
                    setupLatexAutocomplete(aceRef);
                  }}
                  width="100%"
                  height="100%"
                />

                <SpellingSidebar
                  isOpen={isOpen}
                  onClose={onClose}
                  totalUS={totalUS}
                  totalUK={totalUK}
                  allKeys={allKeys}
                  stats={stats}
                  handleConvert={handleConvert}
                  editorRef={editorRef} // Pass the ref here
                  handleMajor={handleMajor}
                />
              </Box>
            </>
          )}
        </span>
      </div>
    </>
  );
});

//Dispatch state to props redux
const mapStateToProps = (state, ownProps) => ({
  corrections: state.EditTool.EditCorrections,
  data: state.correction.corrections,
  states: state,
  latexsearch: state.latexsearch.latexSearch,
  selection: state.toolsearch.toolSearch,
  query: state.queries.queries,
  editing: state.eplStyles.function,
  editTool: state.toolStyles.function,
  editRejected: state.editToolRejected.editReject,
  isChecked: state.toolStyles.isChecked,

  compileTex: state.compileTex.compile,
  compileTrack: state.trackCompile.trackcompile,
  TexcompileTrig: state.compileTrig.compileTrigger,
  TrackcompileTrig: state.compileTrackTrig.compileTrackTrigger,
  projectMode: state.projectMode.projectMode,
  updateCorrections: state.updateCorrections.corrections,
  updateToolCorrections: state.updateToolCorrections.corrections,
  currentClient: state.clientSelect.clientselect,

  showSuggestion: state.editToolRejected.showSuggestion,
  autoSuggestions: state.autoSuggestion.suggestions,
  showIsChecked: state.autoSuggestion.isChecked,
  isLoadingSuggestions: state.editToolRejected.isLoadingSuggestion,
  showautosuggestion: state.editToolRejected.showautosuggestion,
  clearAllTrigger: state.editToolRejected.clearAllTrigger,
  autoapply: state.autoSuggestion.autoapply,
  autoSuggestionsRejected: state.editToolRejected.autoSuggestionReject,
  triggerToolStyles: state.autoSuggestion.triggerToolStyles,
  pendingAIEdit: state.autoSuggestion.pendingAIEdit,


});

//Dispatch action redux
const mapDispatchToProps = (dispatch) => {
  return {
    exampleAction: (data) => dispatch({ type: "EDIT", payload: data }),
    editToolAction: (data) => dispatch({ type: "EDITTOOL", payload: data }),
    editToolRejecteds: (data) => dispatch({ type: "AddReject", payload: data }),
    querydata: (data) => dispatch({ type: "QueryEdit", payload: data }),
    uploadtex: (data) => dispatch({ type: "UploadTex", payload: data }),
    pdfsearch: (data) => dispatch({ type: "pdfSearch", payload: data }),
    compileTrigger: () => dispatch({ type: "TRIGGER_COMPILE" }),
    compileTrackTrigger: () => dispatch({ type: "TRIGGER_TRACK_COMPILE" }),
    toolStyles: (data) => dispatch({ type: "ToolSubmit", payload: data }),
    clientSelect: (data) => dispatch({ type: "clientselect", payload: data }),
    editToolRejected: () => dispatch({ type: "EmptyReject", payload: [] }),
    uploadAutoSuggestions: (data) => dispatch({ type: "addAutoSuggestion", payload: data }),
    showsuggestion: () => dispatch({ type: "showsuggestion" }),
    NoSuggestions: () => dispatch({ type: "Dontshowsuggestion" }),
    clearAutoSuggestionRejects: () => dispatch({ type: "EmptyAutoSuggestionReject" }),
    clearAutoSuggestions: () => dispatch({ type: "clearAutoSuggestion" }),
    startLoading: () => dispatch({ type: "StartLoadingSuggestion" }),
    StopLoading: () => dispatch({ type: "stopLoadingSuggestion" }),
    onIsChecked: () => dispatch({ type: "onIsChecked" }),
    offIsChecked: () => dispatch({ type: "offIsChecked" }),
    changeisChecked: () => dispatch({ type: "changeIsChecked" }),
    autoapplyonoff: () => dispatch({ type: "autoapplyonoff" }),
    removeStaleAutoSuggestions: (ids) => dispatch({ type: "removeStaleAutoSuggestions", payload: ids }),
    addAutoSuggestionReject: (data) => dispatch({ type: "AddAutoSuggestionReject", payload: data }),
    removeAutoSuggestion: (data) => dispatch({ type: "removeAutoSuggestion", payload: data }),
    setPendingAIEdit: (data) => dispatch({ type: "setPendingAIEdit", payload: data }),
    clearPendingAIEdit: () => dispatch({ type: "clearPendingAIEdit" }),


  };
};

export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
})(AceFunctional);
